import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { normalizeAuthEmail } from '../../hooks/authInputUtils.js';
import Logo from '../Logo';

export default function ForgotPassword({ onBackToLogin, onBackHome }) {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);

    const normalizedEmail = normalizeAuthEmail(email);
    if (!normalizedEmail) {
      setError('Please enter your email address.');
      return;
    }

    setLoading(true);
    const redirectTo = `${window.location.origin}/reset-password`;
    const { error: resetError } = await requestPasswordReset(normalizedEmail, redirectTo);
    setLoading(false);

    if (resetError) {
      setError(resetError.message);
      return;
    }

    setMessage('Password reset email sent. Check your inbox to continue.');
  };

  return (
    <main className="auth-page">
      <div className="auth-shell">
        <section className="auth-visual">
          <button type="button" className="auth-back-link" onClick={onBackHome}>
            Back to home
          </button>
          <div className="auth-brand">
            <div className="auth-brand-mark">
              <Logo width={28} height={28} />
            </div>
            <span>GoHalfsies</span>
          </div>
          <h1>Reset your password.</h1>
          <p>Enter your account email and we will send you a secure reset link.</p>
        </section>

        <section className="auth-form-card">
          <p className="auth-eyebrow">Account recovery</p>
          <h2>Forgot password</h2>
          <p className="auth-subhead">Use the same email you use to sign in.</p>

          {error && <div className="auth-error">{error}</div>}
          {message && <div className="auth-message-card">{message}</div>}

          {!message && (
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  autoCapitalize="none"
                  autoCorrect="off"
                  spellCheck={false}
                  inputMode="email"
                  placeholder="name@example.com"
                  disabled={loading}
                />
              </div>

              <button type="submit" className="submit-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </button>
            </form>
          )}

          <div className="auth-switch-row">
            <span>Remembered your password?</span>
            <button type="button" className="auth-switch-btn" onClick={onBackToLogin}>
              Back to login
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}
